module.exports = __webpack_public_path__ + "static/878854774.a0c2b1c1.jpg";